// material-ui
import AddIcon from '@mui/icons-material/Add'
import {
  CardActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Switch,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import { useParams } from 'react-router-dom'

import { Button, Divider, Grid, Stack, Typography } from '@mui/material'
import rq from 'components/RedQuick'
import RedQuickOrderedList from 'components/RedQuickOrderedList'
import { uuid } from 'components/util'
import * as SC from 'features/shared_components'
import { gridSpacing } from 'store/constant'
import TitleService from 'title-service'
import SecondaryAction from 'ui-component/cards/CardSecondaryAction'
import SubCard from 'ui-component/cards/SubCard'
import AnimateButton from 'ui-component/extended/AnimateButton'

// assets
import Busy from 'components/Busy'
import SeasonForm from 'components/SeasonForm'
import { getUserClaims } from 'features/application/application-slice'
import * as autoThunks from 'features/auto-thunks'
import { get_all_media } from 'features/media/media-slice'
import {
  get_all_season,
  get_selected_season,
  setSelectedseason,
} from 'features/season/season-slice'
import {
  get_all_series,
  get_selected_series,
  setSelectedseries,
} from 'features/series/series-slice'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  const params = useParams()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let season_list = useSelector(get_all_season)
  let season = useSelector(get_selected_season)
  let series_list = useSelector(get_all_series)
  let series = useSelector(get_selected_series)
  let media_list = useSelector(get_all_media)
  const [mediaFilter, setMediaFilter] = React.useState(null)
  const [contextId, setContextId] = React.useState(null)
  const [tempSeasonList, setTempSeasonList] = React.useState(null)
  const [sortSeason, setSortSeason] = React.useState(null)
  const [progressContext, setProgressContext] = React.useState(null)
  const [currentSeason, setCurrentSeason] = React.useState(null)
  const [isUploading, setIsUploading] = React.useState(null)
  const [seasonValid, setSeasonValid] = React.useState(null)
  const [seasonDirty, setSeasonDirty] = React.useState(null)
  const [mediaDirty, setMediaDirty] = React.useState(null)
  const [tempSeasonListDirty, setTempSeasonListDirty] = React.useState(null)
  const [seasonOrdersArgs, setSeasonOrdersArgs] = React.useState(null)

  useEffect(() => {
    if (claims?.user && params?.id && series) {
      dispatch(
        autoThunks.get_content_house_seasons({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.user, params?.id, contextId, progressContext, series])
  useEffect(() => {
    if (claims?.user && params?.id) {
      dispatch(
        autoThunks.get_content_house_series_on_seasons({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.user, params?.id, contextId])
  useEffect(() => {
    if (claims?.user && params?.id && series) {
      dispatch(
        autoThunks.get_content_house_medias_for_season_configurations({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.user, params?.id, contextId, progressContext, series])
  useEffect(() => {
    if (claims?.user && params?.id && series) {
      function update_series(): any {
        if (series?.id) {
          setCurrentSeason({
            ...currentSeason,
            seriesId: series.id,
          })
        }
      }
      update_series()
    }
  }, [claims?.user, series, params?.id, contextId, progressContext])
  useEffect(() => {
    if (claims?.user && seasonOrdersArgs) {
      dispatch(
        autoThunks.update_series_season_order({
          fire_user: claims?.user,
          contentHouseId: params?.id,
          seasonOrderArgs: (() => {
            function getSeasonOrderArgs(): any {
              return seasonOrdersArgs
            }
            return getSeasonOrderArgs()
          })(),
        }),
      )
    }
  }, [claims?.user, seasonOrdersArgs])

  function get_current_season(): any {
    return { ...(season || {}), ...(currentSeason || {}) }
  }

  function get_series_select(): any {
    return (
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="series-label">{TitleService('Series')}</InputLabel>
        <Select
          labelId="series-label"
          id="series-select"
          value={series?.id}
          label={TitleService('Series')}
          onChange={(val: any) => {
            dispatch(setSelectedseason(null))
            dispatch(setSelectedseries(val?.target?.value))
            setCurrentSeason({})
            setSeasonDirty(null)
            setSeasonValid(null)
            setMediaDirty(null)
            setContextId(uuid())
          }}
        >
          {(series_list || []).map((seriesItem) => {
            return (
              <MenuItem value={seriesItem.id} key={seriesItem.id}>
                {seriesItem.name}
              </MenuItem>
            )
          })}
        </Select>
        <FormHelperText>{TitleService('Select a series')}</FormHelperText>
      </FormControl>
    )
  }

  let output_get_series_select = get_series_select()

  function submit_button(saveseason: any): any {
    return (
      (seasonValid || seasonValid === null) &&
      !isUploading &&
      (seasonDirty || mediaDirty) && (
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end">
            <AnimateButton>
              <Button
                variant="contained"
                disabled={
                  !(
                    (seasonValid || seasonValid === null) &&
                    !isUploading &&
                    (seasonDirty || mediaDirty)
                  )
                }
                onClick={async () => {
                  await dispatch(saveseason)
                  setMediaDirty(false)
                  setSeasonDirty(false)
                  setContextId(uuid())
                }}
              >
                {TitleService('Submit')}
              </Button>
            </AnimateButton>
          </Stack>
        </Grid>
      )
    )
  }

  let output_submit_button = submit_button(
    autoThunks.storeSeasonForContentHouse({
      fire_user: claims?.user,
      contentHouseId: params?.id,
      season: (() => {
        function getSeason(): any {
          return { ...(season || {}), ...(currentSeason || {}) }
        }
        return getSeason()
      })(),
    }),
  )

  function main_card(seriesselect: any, button: any): any {
    return (() => {
      return (
        <Grid container spacing={gridSpacing}>
          <Busy />
          <Grid item xs={12} sm={6} md={4}>
            {seriesselect}
            <SubCard
              title={TitleService('Seasons')}
              secondary={
                <SecondaryAction
                  icon={
                    <AddIcon
                      onClick={() => {
                        dispatch(setSelectedseason(null))
                        setCurrentSeason({})
                        setSeasonDirty(null)
                        setSeasonValid(null)
                        setMediaDirty(null)
                        setContextId(uuid())
                      }}
                    />
                  }
                />
              }
            >
              <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                  {sortSeason && (
                    <>
                      <Typography variant="h5" sx={{ m: 0 }}>
                        {TitleService('Sort Season')}
                      </Typography>
                      <RedQuickOrderedList
                        value={tempSeasonList || []}
                        rowHeight={60}
                        createElement={(item) => {
                          let media_item = season_list.find(
                            (v) => v.id === item.i,
                          )
                          return SC.seasonListItem(media_item, {})
                        }}
                        onChange={(items) => {
                          if (
                            JSON.stringify(tempSeasonList) !==
                            JSON.stringify(items.map((v) => v.i))
                          ) {
                            setTempSeasonList(
                              items
                                .sort((a, b) => {
                                  return a.y - b.y
                                })
                                .map(
                                  (v) =>
                                    series?.seasons?.find((y) => y.id == v.i),
                                ),
                            )
                            setTempSeasonListDirty(true)
                          }
                        }}
                      />
                    </>
                  )}
                  {!sortSeason &&
                    SC.seasonList(
                      season_list
                        .filter((temp) => {
                          return temp.seriesId === series?.id
                        })
                        .sort((a, b) => {
                          if (series?.seasons) {
                            let a_index = series?.seasons?.findIndex(
                              (v) => v.id === a.id,
                            )
                            let b_index = series?.seasons?.findIndex(
                              (v) => v.id === b.id,
                            )
                            return a_index - b_index
                          }
                          return 0
                        })
                        .map((v) => {
                          return {
                            ...v,
                            selected: season?.id === v?.id,
                          }
                        }),
                      (item) => {
                        dispatch(setSelectedseason(item.id))
                        setCurrentSeason({})
                        setSeasonDirty(null)
                        setSeasonValid(null)
                        setMediaDirty(null)
                        setContextId(uuid())
                      },
                      theme,
                    )}
                </Grid>
              </Grid>
              <Divider />
              <CardActions>
                <Grid container spacing={1}>
                  <Grid item>
                    <FormControl>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Switch
                              value={sortSeason}
                              onChange={(evt) => {
                                if (evt.currentTarget.checked) {
                                  setTempSeasonList(series?.seasons)
                                  setTempSeasonListDirty(false)
                                }
                                setSortSeason(evt.currentTarget.checked)
                              }}
                            />
                          }
                          label={TitleService('Sort')}
                        />
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  {tempSeasonListDirty && (
                    <Grid item>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setSeasonOrdersArgs({
                            seriesId: series?.id,
                            seasons: tempSeasonList,
                          })
                          setTempSeasonListDirty(false)
                        }}
                      >
                        {TitleService('Save')}
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </CardActions>
            </SubCard>
          </Grid>
          <Grid item xs={12} sm={6} md={8}>
            <SubCard title={TitleService('Season')}>
              <SeasonForm
                page={undefined}
                form={get_current_season()}
                context={{
                  id: contextId,
                }}
                onUpdate={(form, valid, dirty) => {
                  setSeasonValid(valid)
                  setSeasonDirty(dirty)
                  setCurrentSeason({ ...form })
                }}
              />
              <Grid container spacing={gridSpacing}>
                <Grid item xs={6} sm={6} md={6}>
                  <rq.RedQuickTextField
                    title={TitleService('Filter')}
                    value={mediaFilter || ''}
                    onChange={(val) => {
                      setMediaFilter(val)
                    }}
                  />
                  {SC.mediaList(
                    media_list
                      .filter((temp) => {
                        let selected_items = get_current_season().media || []
                        return !selected_items
                          .filter((x) => x)
                          .some((b) => b.id === temp.id)
                      })
                      .filter((media) => {
                        if (mediaFilter) {
                          return (
                            `${media.name}`
                              .toLowerCase()
                              .indexOf(`${mediaFilter}`.toLowerCase()) !== -1
                          )
                        }
                        return true
                      }),
                    (item) => {
                      let temp = { ...(currentSeason || {}) }
                      temp.media = temp.media || []
                      if (!temp.media.some((v) => v.id === item.id)) {
                        temp.media.push(item)
                        setCurrentSeason({ ...temp })
                        setMediaDirty(true)
                      }
                    },
                    theme,
                  )}
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <Typography variant="h5" sx={{ m: 0 }}>
                    {TitleService('Season Playlist Order')}
                  </Typography>
                  <RedQuickOrderedList
                    value={get_current_season().media || []}
                    rowHeight={60}
                    contextId={season?.id}
                    createElement={(item) => {
                      let media_item = media_list.find((v) => v.id === item.i)
                      return SC.makeMediaListItem(
                        media_item,
                        (item) => {
                          let temp = currentSeason
                          temp.media = temp.media || []
                          temp.media = temp.media
                            .filter((x) => x)
                            .filter((x) => x.id !== item.id)
                          setCurrentSeason({ ...temp })
                          setMediaDirty(true)
                        },
                        theme,
                      )
                    }}
                    onChange={(items) => {
                      console.log(items)
                      let temp = currentSeason || {}
                      temp.media = temp.media || []
                      if (
                        JSON.stringify(temp.media) !==
                        JSON.stringify(items.filter((x) => x).map((v) => v.id))
                      ) {
                        temp.media = items
                          .filter((x) => x)
                          .sort((a, b) => {
                            return a.y - b.y
                          })
                          .map((v) => {
                            return media_list
                              .filter((x) => x)
                              .find((y) => y.id === v.i)
                          })
                        setCurrentSeason({ ...temp })
                        setMediaDirty(true)
                      }
                    }}
                  />
                </Grid>
              </Grid>
              {button}
            </SubCard>
          </Grid>
        </Grid>
      )
    })()
  }

  let output_main_card = main_card(
    output_get_series_select,
    output_submit_button,
  )

  return output_main_card
}
